const INITIAL_STATE = {
    id: 2,
    secret: "",
    name: "",
    description: "",
    logo: "",
    base_url: ""
};

export default function (state = INITIAL_STATE, action) {
    if (action.type === "SET_APPLICATION_DATA") {
        return {...state, ...action.payload};
    } else {
        return state;
    }
}
